import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useSuggestResponse } from "@/hooks/useChat.hooks";
import {
  useChatContext,
  useMessageComposer,
  useMessageInputContext,
} from "stream-chat-react";

export const SuggestButton = () => {
  const { t } = useTranslation();
  const { textareaRef } = useMessageInputContext();
  const messageComposer = useMessageComposer();
  const { channel } = useChatContext();
  const { mutateAsync, isPending } = useSuggestResponse();

  const onSuggest = async () => {
    if (!channel?.id) return;
    const res = await mutateAsync(channel.id);
    const suggestion = res?.text || "";
    const textarea = textareaRef.current as HTMLTextAreaElement | null;

    if (!textarea) return;

    const currentValue = textarea.value || "";
    await messageComposer.textComposer.insertText({
      text: suggestion,
      selection: { start: 0, end: currentValue.length },
    });

    setTimeout(() => {
      textarea.focus();
      const newPosition = suggestion.length;
      textarea.setSelectionRange(newPosition, newPosition);
    }, 0);
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="absolute top-1.5 right-2 overflow-hidden px-2 gap-2 rounded-md bg-white border-slate-200 text-xs"
      onClick={onSuggest}
      disabled={isPending}
      title={t("chats.aiSuggest", { defaultValue: "AI Suggest" })}
    >
      {isPending ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : (
        <Sparkles className="w-4 h-4" />
      )}
    </Button>
  );
};
